import type {
    NavLink,
    ShopCategory,
    SiteConfig,
    Store
} from '@/types'

import { getOrigin } from '@/lib/window'
import { editorial, media } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: 'Elio',
    legalName: 'Elio Studio',
    description: "Elio is a Berlin studio making essentials for the unordinary: technical outerwear, heavy knits and raw denim, cut in numbered runs of 300 and repaired for life.",
    placeholder: 'Essentials for the unordinary.',
    url: getOrigin(),
    email: 'hello@elio.studio',
    season: 'SS26 — Essentials 04',
    tagline: 'Essentials for the unordinary.',
    ogImage: media.elioLabelDetail
}

export const navLinks: Array<NavLink> = [
    { label: 'Shop', href: '/shop', index: '01' },
    { label: 'Lookbook', href: '/lookbook', index: '02' },
    { label: 'Journal', href: '/journal', index: '03' },
    { label: 'About', href: '/about', index: '04' },
    { label: 'Contact', href: '/contact', index: '05' }
]

export const shopCategories: Array<ShopCategory> = [
    { label: 'Outerwear', slug: 'outerwear' },
    { label: 'Knitwear', slug: 'knitwear' },
    { label: 'Denim', slug: 'denim' },
    { label: 'Accessories', slug: 'accessories' }
]

export const stores: Array<Store> = [
    {
        city: 'Berlin',
        district: 'Mitte',
        address: 'Torstraße 140, 10119 Berlin',
        hours: 'Mon–Sat 11–20 · Sun 12–18',
        timeZone: 'Europe/Berlin',
        short: 'BER',
        image: editorial.storeBerlin,
        imageAlt: "A minimal store with a glass front, pale wood floors and a single rail"
    },
    {
        city: 'Tokyo',
        district: 'Aoyama',
        address: '5-2-15 Minami-Aoyama, Minato-ku',
        hours: 'Mon–Sat 11–20 · Sun 12–18',
        timeZone: 'Asia/Tokyo',
        short: 'TYO',
        image: editorial.storeTokyo,
        imageAlt: "Neatly folded knits and hanging garments on open store shelving"
    },
    {
        city: 'New York',
        district: 'SoHo',
        address: '48 Wooster Street, NY 10013',
        hours: 'Mon–Sat 11–20 · Sun 12–18',
        timeZone: 'America/New_York',
        short: 'NYC',
        image: editorial.storeNewYork,
        imageAlt: "A lit corner shopfront on a wet street at dusk"
    }
]

export const socialLinks: Array<{ label: string, href: string }> = [
    { label: 'Instagram', href: 'https://instagram.com/' },
    { label: 'TikTok', href: 'https://tiktok.com/' },
    { label: 'Pinterest', href: 'https://pinterest.com/' },
    { label: 'X', href: 'https://x.com/' }
]
